<button-component [config]="configs()" />
